import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const Modal = ({ isOpen, onClose, title, children, size = 'medium', bare = false }) => {
  // Закрываем по бэкдропу только если и нажатие, и отпускание были на самом
  // бэкдропе. Иначе выделение текста в поле с протяжкой наружу закрывало окно.
  const downOnBackdrop = useRef(false);
  const onBackdropDown = (e) => { downOnBackdrop.current = e.target === e.currentTarget; };
  const onBackdropClick = (e) => { if (e.target === e.currentTarget && downOnBackdrop.current) onClose(); };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  // Bare-режим: только портал + затемнённый бэкдроп; всю карточку рисует caller
  // (используется для модалок админки в стиле дизайна — .adm-modal).
  if (bare) {
    return createPortal(
      <div className="adm-backdrop" onMouseDown={onBackdropDown} onClick={onBackdropClick}>
        {children}
      </div>,
      document.body
    );
  }

  const getWidth = () => {
    switch (size) {
      case 'small':
        return '420px';
      case 'large':
        return '820px';
      default:
        return '600px';
    }
  };

  // Рендерим в body через портал: иначе position:fixed считается не от
  // всего экрана, а от ближайшего предка с transform/will-change (.view-fade),
  // и затемняется только область контента, а окно уезжает за пределы экрана.
  return createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(6, 4, 12, 0.6)',
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        boxSizing: 'border-box',
        zIndex: 1000,
        overflowY: 'auto',
        animation: 'pgfade .15s ease',
      }}
      onMouseDown={onBackdropDown}
      onClick={onBackdropClick}
    >
      <div
        style={{
          background: 'var(--lg-modal, #fff)',
          borderRadius: '20px',
          padding: '24px',
          width: getWidth(),
          maxWidth: '100%',
          maxHeight: 'calc(100vh - 48px)',
          overflowY: 'auto',
          margin: 'auto',
          boxShadow: '0 24px 60px rgba(0, 0, 0, 0.35)',
          border: '1px solid var(--border, transparent)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-1, #1a1e27)' }}>{title}</h3>
          <button
            onClick={onClose}
            aria-label="Закрыть"
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              lineHeight: 1,
              cursor: 'pointer',
              color: 'var(--text-3, #8a94a6)',
            }}
          >
            ×
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;